$(document).ready(function() {
  $('.next-page-link').not(':last').remove();
  $.fn.scroll4ever = function(options, asd)
  {
    var settings = $.extend({
      trigger : false,
      container: $(this),
      selector: false,
      distance : 0,
      start : function(){},
      complete : function(){},
      debug : false
    }, options);

    var scope = $(this);
    var loading = false;

    var log = function(obj) { if (settings.debug && console.log != undefined) { console.log(obj); } }
    log('initialized');
    log(scope);
    log(settings);

    $(this).on('click', settings.trigger, function(){
      log('triggered');
      settings.start();
      loading = true;
      var url = scope.find(settings.trigger).attr('href');
      log('requesting: ' + url);
      $('<div></div>').load(url, function() {
        var newScope = $(this);
        scope.find(settings.trigger).replaceWith(newScope.find(settings.trigger));
        scope.find(settings.container).append(newScope.find(settings.selector));
        loading = false;
        log('done');
        settings.complete();
      });
      return false;
    });

    $('#overflow-y-auto').on('scroll',function(){
      // console.log(`${$(this).scrollTop()}, ${$('#row-item-lists').height() - $(window).height() + settings.distance}, distance: ${settings.distance}`)
      if ($(this).scrollTop() >= ($('#row-item-lists').height() - $(window).height() + settings.distance))
      {
        if (!loading)
        {
          $(settings.trigger).trigger('click');
        }
      }
    });
  };

  $('#overflow-y-auto').scroll4ever({
    // selector of the trigger link
    trigger:'.next-page-link', 

    // element where next page items are going to be added
    container: '#item-lists', 

    // elements to be added to the page
    selector:'.item-list', 

    distance: parseInt($('#overflow-y-auto').attr('data-distance')),

    // callback called when a new page is loading
    start: function(){
      $(this.container).append("<div class='text-center' id='text-loading'><div class='spinner-border'></div></div>")
    },

    // fired when the page is loaded
    complete: function(){
      var total_records = document.querySelector('#total-records');
      if (total_records != null) {
        total_records.textContent = document.querySelectorAll('.item-list').length;
      }
      $('#text-loading').remove();
      $('.next-page-link').not(':last').remove();
    },
  });
})
